/**
 * Firebase 設定定数。
 *
 * Web ブラウザでの Google Sign-In（Firebase Auth の popup）に使用する。
 * 実キーは `.env.<mode>` 側に `VITE_FIREBASE_*` として入れる運用。
 *
 * 未設定時は `null` を返し、呼び出し側が「Firebase 未初期化」として扱えるようにする。
 * これは T12 実装時点では実キー未配布の段階でもビルド / 起動が通る必要があるため。
 *
 * 関連: `src/services/firebase.ts`, `src/services/auth.ts`, `docs/AUTH_SETUP.md`
 */

export interface FirebaseWebConfig {
  apiKey: string
  authDomain: string
  projectId: string
  // optional（将来 FCM / Analytics を有効化するときに使う）
  appId?: string
  messagingSenderId?: string
  storageBucket?: string
}

/**
 * 現在のビルドに対する Firebase Web 設定を返す。
 * 必須フィールド（apiKey / authDomain / projectId）のいずれかが欠けていれば null を返す。
 */
export function getFirebaseWebConfig(): FirebaseWebConfig | null {
  const apiKey = (import.meta.env.VITE_FIREBASE_API_KEY || '').trim()
  const authDomain = (import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '').trim()
  const projectId = (import.meta.env.VITE_FIREBASE_PROJECT_ID || '').trim()

  if (!apiKey || !authDomain || !projectId) return null

  const config: FirebaseWebConfig = {
    apiKey,
    authDomain,
    projectId,
  }
  const appId = (import.meta.env.VITE_FIREBASE_APP_ID || '').trim()
  if (appId) config.appId = appId
  const messagingSenderId = (import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '').trim()
  if (messagingSenderId) config.messagingSenderId = messagingSenderId
  const storageBucket = (import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || '').trim()
  if (storageBucket) config.storageBucket = storageBucket

  return config
}
